import { IHasFullName } from "../../interfaces/utilities/IHasFullName";

export function getFullName<T extends IHasFullName>(person: T): string {
  return `${person.surname} ${person.name} ${person.patronymic || ""}`.trim();
}
